import { map } from 'lodash';

import * as moment from 'moment';
import { AttendeesList } from './attendeesList-model';

export class SubmitScheduleMeetingModel {

    parentSk: string;
    personSk: string;
    meetingSk: string;
    studentSk: string;
    nycId: string;
    meetingType: any;
    meetingEndTime: any;
    actualoccurDate: any;
    origScheduleDt: any;
    currScheduleDt: any;
    parentReqReschedule: boolean;
    parentConfirm: boolean;
    formJson: string;
    location: string;
    student: Student;
    parent: Parent;
    generalEducationTeacher: GeneralEducationTeacher;
    schoolSocialWorker: SchoolSocialWorker;
    schoolPsychologist: SchoolPsychologist;
    relatedServiceProvider: RelatedServiceProvider;
    districtRepresentative: DistrictRepresentative;
    principal: Principal;
    teacher: Teacher;
    specialEducationTeacher: SpecialEducationTeacher;
    attend: AttendeesList[];
    subMeetingType: number;
    assessments: Assessment[];
    additionalInfo: string;
    requiredAttendees: [];
    optionalAttendees: [];
    assessmentsList: [];
    evaluationSk: string;
    shmMinDate: Date;
    pwnNoticeDate: Date;
    constructor(data: any) {
        const combinedMeetingDateTime: string = moment(data?.meetingDate)
            .set({
                hour: moment(data?.meetingStartTime).hours(),
                minute: moment(data?.meetingStartTime).minutes(),
            })
            .format('MM/DD/YYYY hh:mm A');
        this.meetingSk = data.meetingSk;
        this.parentSk = data.parentSk;
        this.personSk = data.personSk;
        this.studentSk = data.studentSk;
        this.nycId = data.nycId;
        this.actualoccurDate = moment(combinedMeetingDateTime).local().format('YYYY-MM-DDTHH:mm:ss') + 'Z';
        this.currScheduleDt = moment(combinedMeetingDateTime).local().format('YYYY-MM-DDTHH:mm:ss') + 'Z';
        this.origScheduleDt = moment(combinedMeetingDateTime).local().format('YYYY-MM-DDTHH:mm:ss') + 'Z';
        this.location = `${data?.meetingStreetAddress1}${data?.meetingFloorRoom ? ', ' + data.meetingFloorRoom : ''}`
        this.meetingType = data.meetingType === 0 ? 'SHM' : data.meetingType === 1 ? 'GenEd' : 'IEP';
        this.meetingEndTime = data?.meetingEndTime;
        this.formJson = JSON.stringify({ ...data, meetingStartTime: combinedMeetingDateTime });
        this.parentReqReschedule = false;
        this.parentConfirm = true;
        this.student = new Student(data?.student);
        this.parent = new Parent(data?.parent);
        this.student = new Student(data?.student);
        this.generalEducationTeacher = new GeneralEducationTeacher(data?.generalEducationTeacher);
        this.specialEducationTeacher = new SpecialEducationTeacher(data?.specialEducationTeacher);
        this.schoolSocialWorker = new SchoolSocialWorker(data?.schoolSocialWorker);
        this.schoolPsychologist = new SchoolPsychologist(data?.schoolPsychologist);
        this.relatedServiceProvider = new RelatedServiceProvider(data?.relatedServiceProvider);
        this.districtRepresentative = new DistrictRepresentative(data?.districtRepresentative);
        this.principal = new Principal(data?.principal);
        this.teacher = new Teacher(data?.teacher);
        this.attend = map(data?.attendee, (row: AttendeesList) => new AttendeesList(row));
        this.subMeetingType = data.subMeetingType;
        this.additionalInfo = data?.additionalInfo;
        this.requiredAttendees = data?.requiredAttendees;
        this.optionalAttendees = data?.optionalAttendees;
        this.assessmentsList = data?.assessmentsList;
        this.evaluationSk = data?.evaluationSk;
    }

    get id(): string {
        return this.parentSk
    }

}


export class Student {
    studentName: string;
    studentEmail: string;
    constructor(data: any) {
        this.studentName = data?.studentName;
        this.studentEmail = data?.studentEmail;
    }

}

export class Assessment {
    AssessmentSk?: string;
    assessmentSk?: string;
    constructor(data: any) {
        this.AssessmentSk = data?.AssessmentSk;
        this.assessmentSk = data?.assessmentSk;
    }
}


export class Parent {
    parentName: string;
    parentEmail: string;
    constructor(data: any) {
        this.parentName = data?.parentName;
        this.parentEmail = data?.parentEmail;
    }
}

export class GeneralEducationTeacher {
    generalEducationTeacherName: string;
    generalEducationTeacherEmail: string;
    generalEducationTeacherPhoneNumber: string;
    constructor(data: any) {
        this.generalEducationTeacherName = data?.generalEducationTeacherName;
        this.generalEducationTeacherEmail = data?.generalEducationTeacherEmail;
        this.generalEducationTeacherPhoneNumber = data?.generalEducationTeacherPhoneNumber;
    }
}

export class SpecialEducationTeacher {
    specialEducationTeacherName: any;
    specialEducationTeacherEmail: string;
    specialEducationTeacherPhoneNumber: string;
    constructor(data: any) {
        this.specialEducationTeacherName = data?.specialEducationTeacherName;
        this.specialEducationTeacherEmail = data?.specialEducationTeacherEmail;
        this.specialEducationTeacherPhoneNumber = data?.specialEducationTeacherPhoneNumber;
    }
}

export class SchoolSocialWorker {
    schoolSocialWorkerName: any;
    schoolSocialWorkerEmail: string;
    schoolSocialWorkerPhoneNumber: string;
    constructor(data: any) {
        this.schoolSocialWorkerName = data?.schoolSocialWorkerName;
        this.schoolSocialWorkerEmail = data?.schoolSocialWorkerEmail;
        this.schoolSocialWorkerPhoneNumber = data?.schoolSocialWorkerPhoneNumber;
    }
}

export class SchoolPsychologist {
    schoolPsychologistName: string;
    schoolPsychologistEmail: string;
    schoolPsychologistPhoneNumber: string;
    constructor(data: any) {
        this.schoolPsychologistName = data?.schoolPsychologistName;
        this.schoolPsychologistEmail = data?.schoolPsychologistEmail;
        this.schoolPsychologistPhoneNumber = data?.schoolPsychologistPhoneNumber;
    }
}
export class RelatedServiceProvider {
    relatedServiceProviderName: string;
    relatedServiceProviderEmail: string;
    relatedServiceProviderPhoneNumber: string;
    constructor(data: any) {
        this.relatedServiceProviderName = data?.relatedServiceProviderName;
        this.relatedServiceProviderEmail = data?.relatedServiceProviderEmail;
        this.relatedServiceProviderPhoneNumber = data?.relatedServiceProviderPhoneNumber;
    }
}

export class DistrictRepresentative {
    districtRepresentativerName: string;
    districtRepresentativerEmail: string;
    districtRepresentativerPhoneNumber: string;
    constructor(data: any) {
        this.districtRepresentativerName = data?.districtRepresentativerName;
        this.districtRepresentativerEmail = data?.districtRepresentativerEmail;
        this.districtRepresentativerPhoneNumber = data?.districtRepresentativerPhoneNumber;
    }
}

export class Principal {
    principalName: string;
    principalEmail: string;
    constructor(data: any) {
        this.principalName = data?.principalName;
        this.principalEmail = data?.principalEmail;
    }
}

export class Teacher {
    teacherName: string;
    teacherEmail: string;
    constructor(data: any) {
        this.teacherName = data?.teacherName;
        this.teacherEmail = data?.teacherEmail;
    }
}
